import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "DocumentLineDelete" }
const _hoisted_2 = { key: 0 }

import IconButton from "@/components/ds/icon-button/IconButton.vue";
import { PropType } from "vue";
import { Document, Line } from "@/types";
import InnButton from "@/components/ds/button/Button.vue";
import api from "@/api";
import { useUiStore } from "@/stores/ui";


export default /*#__PURE__*/_defineComponent({
  __name: 'DocumentLineDelete',
  props: {
    line: {
        type: Object as PropType<Line>,
        required: true,
    },
    document: {
        type: Object as PropType<Document>,
        required: true,
    },
},
  setup(__props) {

const props = __props;

const uiStore = useUiStore();

const deleteLine = () => {
    api.delete(props.line, "documentLines").then(() => {
        const index = props.document.lines.indexOf(props.line);
        props.document.lines.splice(index, 1);
        uiStore.message("Post verwijderd...");
    });
};

return (_ctx: any,_cache: any) => {
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_dialog, { "max-width": "500" }, {
      activator: _withCtx(({ props: activatorProps }) => [
        _createVNode(IconButton, _mergeProps(activatorProps, {
          "icon-id": "trash",
          variant: "danger"
        }), null, 16)
      ]),
      default: _withCtx(({ isActive }) => [
        _createVNode(_component_v_card, { style: {"padding":"12px"} }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _cache[0] || (_cache[0] = _createTextVNode(" Wil je deze post ")),
                (__props.line.text.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, "(\"" + _toDisplayString(__props.line.text) + "\")", 1))
                  : _createCommentVNode("", true),
                _cache[1] || (_cache[1] = _createTextVNode(" verwijderen? "))
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(InnButton, {
                  onClick: 
                                () => {
                                    isActive.value = false;
                                    deleteLine();
                                }
                            
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" Verwijderen ")
                  ])),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    })
  ]))
}
}

})